






















































import {
  Vue,
  Component
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import {
  FamilyMember,
  FamilyMemberRelationship,
  FamilyMemberStatus,
  UserFeedbackEventAction
} from "@/shared/types";
import DependentTableView from "@/employee/components/settings/profile/DependentTableView.vue";
import EditDependent from "@/employee/components/settings/profile/EditDependent.vue";
import * as RouteNames from "@/employee/route-names";
import { useUserFeedbackStore } from "@/employee/store/userFeedback";
import { useFamilyStore } from "@/employee/store/family";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import { useThemeStore } from "@/shared/store/theme";
import { useNotifierStore } from "@/shared/store/notifier";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

const emptyDependentModel: FamilyMember = {
  id: 0,
  firstName: "",
  lastName: "",
  fullName: "",
  tag: "",
  dateOfBirth: "",
  debitCardHolder: false,
  relationship: FamilyMemberRelationship.Dependent,
  ssn: "",
  status: FamilyMemberStatus.Active
};

@Component({
  components: {
    GenericLoadingSpinner,
    DependentTableView,
    EditDependent
  }
})

export default class Dependents extends Vue {
  userFeedbackStore = useUserFeedbackStore();
  hsabAccountsStore = useHsabAccountsStore();
  familyStore = useFamilyStore();
  themeStore = useThemeStore();
  notifierStore = useNotifierStore();
  featureFlagStore = useFeatureFlagStore();
  custodianSettingsStore = useCustodianSettingsStore();

  editDependentParameters = {
    show: { value: false },
    dependent: { ...emptyDependentModel },
    onSave: this.onSaveDependent,
    toggleClose: this.closeEditDependentForm,
    isNew: true
  };
  showAddDependentSuccessModalWithOrderDebitCardInfo = false;
  RouteNames = RouteNames;

  mounted () {
    this.familyStore.initialize();
  }

  get dependents () {
    const supportedValues = [FamilyMemberRelationship.Spouse, FamilyMemberRelationship.Dependent];

    return this.familyStore
      .familyMembers
      .filter(x => supportedValues.includes(x.relationship));
  }

  get isLoaded () {
    return this.familyStore.isFamilyStateLoaded;
  }

  get portalFunctionalityDisabled (): boolean {
    return this.custodianSettingsStore.portalFunctionalityDisabled;
  }

  get activeDependents () {
    return this.dependents.filter(x => x.status === FamilyMemberStatus.Active);
  }

  get hasActiveDependents () {
    return this.activeDependents && this.activeDependents.length > 0;
  }

  get inactiveDependents () {
    return this.dependents.filter(x => x.status === FamilyMemberStatus.Inactive);
  }

  get hasInactiveDependents () {
    return this.inactiveDependents && this.inactiveDependents.length > 0;
  }

  get debitCardManagementRouteName () {
    return RouteNames.DebitCardManagement;
  }

  showEditDependentForm () {
    this.editDependentParameters.dependent = { ...emptyDependentModel };
    this.editDependentParameters.show.value = true;
    this.userFeedbackStore.setUserFeedbackAction(UserFeedbackEventAction.AddDependent);
  }

  onSaveDependent () {
    return this.familyStore.addFamilyMember(this.editDependentParameters.dependent)
      .then(() => {
        this.editDependentParameters.show.value = false;

        if (this.hsabAccountsStore.debitCardsAvailable) {
          this.showAddDependentSuccessModalWithOrderDebitCardInfo = true;
        } else {
          this.notifierStore.setSuccess("Dependent added.");
        }
      })
      .catch(() => {/*noop*/ });
  }

  closeEditDependentForm () {
    this.editDependentParameters.show.value = false;
  }
}

